// extracted by mini-css-extract-plugin
module.exports = {"FlipFlop":"flip-flop_FlipFlop__q5EqI","right":"flip-flop_right__H5_Ly","left":"flip-flop_left__4D96_","image":"flip-flop_image__uXdIi","appear":"flip-flop_appear__fhnrh"};